/**
 * API Configuration
 * Centralizes all API endpoints and configuration values
 *
 * Usage:
 * import { API_URL, API_BASE_URL, API_CONFIG } from '@/config/api';
 * fetch(`${API_URL}/api/customers`)      // Use API_URL for base URL
 * fetch(`${API_BASE_URL}/customers`)     // Use API_BASE_URL (includes /api)
 */

/**
 * Base server URL (without /api suffix)
 * Use this when you need to construct custom paths
 *
 * Fallback is the production API (zero-localhost rule): dev builds set
 * VITE_API_URL in client/.env; a missing env var must never ship a
 * localhost reference or dead endpoint in a prod bundle.
 */
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.buzzbitx.com';

/**
 * API Base URL (with /api suffix)
 * Use this for standard API calls
 */
export const API_BASE_URL = `${API_URL}/api`;

export const API_CONFIG = {
  /**
   * Base API URL (with /api suffix)
   * @deprecated Use API_BASE_URL instead
   */
  baseUrl: API_BASE_URL,

  /**
   * Shopify OAuth callback URL
   * Used for Shopify app installation flow
   */
  shopifyAuthUrl: `${API_URL}/integrations/shopify/auth`,

  /**
   * Vendor portal base URL
   */
  vendorApiUrl: `${API_BASE_URL}/vendor`,

  /**
   * Request timeout configuration (milliseconds)
   */
  timeouts: {
    default: 30000,      // 30 seconds
    longRunning: 120000  // 2 minutes (for exports, bulk operations)
  },

  /**
   * Pagination defaults
   */
  pagination: {
    defaultLimit: 50,
    maxLimit: 1000
  }
} as const;
